import React from 'react';
import ProgressHeader from './ProgressHeader';
import ContinueButton from './common/ContinueButton';
import { AVAILABILITY_SLOTS } from '../constants/onboardingData';

/**
 * Step 3: Sélection des créneaux de disponibilité
 */
export default function Step3Availability({
  formData,
  currentStepNumber,
  currentStepMessage,
  canContinue,
  onToggleAvailability,
  onContinue,
  onBack,
}) {
  return (
    <div className="min-h-[100dvh] bg-[#F0FDFA] flex flex-col">
      <ProgressHeader
        currentStep={currentStepNumber}
        message={currentStepMessage}
        showBack={true}
        onBack={onBack}
      />

      <div className="flex-1 px-4 pb-4 overflow-y-auto">
        {/* Icône et Titre */}
        <div className="text-center py-6">
          <div className="w-16 h-16 rounded-full bg-[#2DD4BF] flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Quand êtes-vous disponible ?
          </h1>
          <p className="text-gray-500">
            Pour aider votre enfant à travailler
          </p>
          <p className="text-[#059669] font-medium mt-1">
            Vous pouvez choisir plusieurs créneaux
          </p>
        </div>

        {/* Liste des créneaux */}
        <div className="space-y-3">
          {AVAILABILITY_SLOTS.map((slot) => (
            <div
              key={slot.id}
              onClick={() => onToggleAvailability(slot.id)}
              className={`
                bg-white rounded-2xl p-6 shadow-lg border-[3px] cursor-pointer transition-all
                flex items-center gap-4 
                ${formData.availabilitySlots.includes(slot.id)
                  ? 'border-[#059669] bg-[#F0FDFA]'
                  : 'border-gray-100 hover:border-gray-200'
                }
              `}
            >
              {/* Icône */}
              <div className={`
                w-14 h-14 rounded-xl flex items-center justify-center text-2xl
                ${slot.id === 'matin' 
                  ? 'bg-gradient-to-br from-yellow-400 to-orange-400' 
                  : slot.id === 'midi' 
                    ? 'bg-orange-300' 
                    : slot.id === 'apres-ecole' 
                      ? 'bg-orange-400' 
                      : slot.id === 'soir' 
                        ? 'bg-indigo-400' 
                        : slot.id === 'weekend' 
                          ? 'bg-[#2DD4BF]' 
                          : ''
                }
              `}>
                {slot.icon}
              </div>

              {/* Texte */}
              <div className="flex-1">
                <p className="font-semibold text-gray-800">{slot.label}</p>
                <p className="text-gray-500 text-sm">{slot.time}</p>
              </div>

              {/* Checkbox */}
              <div className={`
                w-6 h-6 rounded-full border-2 flex items-center justify-center
                ${formData.availabilitySlots.includes(slot.id)
                  ? 'border-0 bg-[#059669]'
                  : 'border-gray-300'
                }
              `}>
                {formData.availabilitySlots.includes(slot.id) && (
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Astuce */}
        <div className="mt-6 bg-[#E0F7FA] rounded-xl p-4 border border-[#B2EBF2]">
          <div className="flex items-start gap-2">
            <span className="text-xl">💡</span>
            <p className="text-gray-700 text-sm">
              <span className="font-semibold">Astuce :</span> Les parents qui s'engagent le week-end voient les meilleurs résultats !
            </p>
          </div>
        </div>
      </div>

      {/* Bouton Continuer */}
      <div className="sticky bottom-0 bg-[#F0FDFA] p-4 border-t border-gray-100">
        <ContinueButton
          onClick={onContinue}
          disabled={!canContinue}
        />
      </div>
    </div>
  );
}
